import { createSlice } from "@reduxjs/toolkit"

// Check localStorage when app starts

const initialState = {
  search: "",
}

export const Global = createSlice({
  name: "global",
  initialState,
  reducers: {
    updateSearch: (state, action) => {
      state.search = action.payload
    },
  },
})

export const { updateSearch } = Global.actions
export default Global.reducer
